<template>
    <footer class="main-footer d-flex justify-content-between align-items-center flex-wrap">
        <div class="footer-left">
            <a href="">Goconnexus.com</a>.
        </div>
        <div class="footer-center text-center flex-grow-1 ">
            <b class="d-none d-sm-inline">&copy; {{ startDate }} - {{ endDate }}</b>
        </div>
        <div class="footer-right text-end">
            <b v-if="mode.split('-')[0] !== 'Production'" :class="color">{{ mode }}</b>
            <b v-else>version</b>
            {{ version }}
        </div>
    </footer>
</template>

<script lang="ts" setup>
const version = import.meta.env.VITE_VERSION;
const mode = import.meta.env.VITE_APP_MODE;
const color = import.meta.env.VITE_ICON_COLOR;
const startDate = '2010';
const endDate = new Date().getFullYear();
</script>